export default __webpack_public_path__ + "static/media/eb-wht-banner-1.2c5d7e2e.jpg";